export const STATUS_COLORS = {
  prospect: '#2f6ee5',
  client: '#0ea57a',
  lapsed: '#f2994a',
  rejected: '#e24d5f',
  unsaved: '#9aa5bb',
};

export const LIGHT_THEME = {
  primary: '#2f6ee5',
  primaryHover: '#215fce',
  bgBase: '#f5f6fa',
  bgLayout: '#f1f3f8',
  bgSidebar: '#ffffff',
  bgSidebarElevated: '#f2f7ff',
  bgCard: '#ffffff',
  bgCardMuted: '#f7f9fc',
  textStrong: '#13264f',
  text: '#57607a',
  textMuted: '#8a93aa',
  border: '#e2e8f4',
  borderStrong: '#ccd6e9',
  shadow: '0 14px 28px rgba(17, 32, 66, 0.08)',
  shadowSoft: '0 6px 14px rgba(17, 32, 66, 0.06)',
  radius: '16px',
};

export const DARK_THEME = {
  primary: '#66a1ff',
  primaryHover: '#4f93ff',
  bgBase: '#0f1424',
  bgLayout: '#121a2c',
  bgSidebar: '#0a1020',
  bgSidebarElevated: '#18233a',
  bgCard: '#18233a',
  bgCardMuted: '#1f2d49',
  textStrong: '#e7ecf6',
  text: '#c1cbe2',
  textMuted: '#95a4c4',
  border: '#2a3857',
  borderStrong: '#3b4c72',
  shadow: '0 12px 30px rgba(2, 6, 16, 0.45)',
  shadowSoft: '0 6px 18px rgba(2, 6, 16, 0.35)',
  radius: '16px',
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'Prospect':
      return STATUS_COLORS.prospect;
    case 'Client':
      return STATUS_COLORS.client;
    case 'Lapsed Client':
      return STATUS_COLORS.lapsed;
    case 'Rejected':
      return STATUS_COLORS.rejected;
    default:
      return STATUS_COLORS.unsaved;
  }
};

export const applyThemeVariables = (theme) => {
  const root = document.documentElement;
  Object.entries(theme).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
};
